module.exports = __webpack_public_path__ + "fonts/df8c626.ttf";